module.exports = __webpack_public_path__ + "img/d11-min.ee2f8385.png";